// entries are compared using startsWith, so exact match or prefix only to be used
const paramsToPreserve = ['clickid', 'irclickid', 'gclid', 'msclkid', 'utm_', 'gtm_debug', 'pc'];

const preserveMarketingParams = search => {
  if (!search) return '';
  const paramArray = search.substring(search.indexOf('?') + 1).split('&');
  const paramsFiltered = paramArray.filter(param => paramsToPreserve.some(compareParam => param.startsWith(compareParam)));

  return `${paramsFiltered.join('&')}`;
};

export default preserveMarketingParams;
